export function obterDadosUsuario(userData: {jwt: string, user: any}) {
  let areasAndRoles: any = {};
  const idUsuario = userData.user.id;
  const nomeUsuario = userData.user.nome_completo;

  areasAndRoles[userData.user.role.name.toUpperCase()] = userData.user.role.name.toUpperCase();
  
  return { idUsuario, areasAndRoles, nomeUsuario};
}